module.exports = __webpack_public_path__ + "img/logos (1).c1f649e6.webp";